import styled from 'styled-components';

const getBackground = ({ isOver, isActive }) => {
  if (isOver) {
    return '#5d6574';
  }

  if (isActive) {
    return '#4c5463';
  }

  return '#3b4251';
};

export default styled.div`
  position: relative;
  user-select: none;
  margin: 0 0 8px 0;
  border-radius: 10px;
  font-size: 12px;
  padding: 15px;

  // change background colour if dragging
  background: ${getBackground};
  box-shadow: 0 0 10px 0
    rgba(43, 48, 58, ${({ isActive }) => (isActive ? 0.5 : 0.1)});
  cursor: pointer;

  z-index: ${({ isActive }) => (isActive ? 1 : 'auto')};

  :hover {
    background: #4c5463;
  }
`;
